import { useInitiateOauthTrigger } from 'hooks/useInitiateOauthTrigger/useInitiateOauthTrigger'
import { InitiateOauthTriggerProps } from 'components/ConnectIntegrationTrigger/Types'
import { PressResponder } from '@react-aria/interactions'

export const InitiateOauthTrigger = (props: InitiateOauthTriggerProps) => {
  const { children, ...hookProps } = props
  const { handleConnect } = useInitiateOauthTrigger(hookProps)

  return <PressResponder onPress={handleConnect}>{children}</PressResponder>
}
